export const MAX_ALLOWED_ATTACHMENTS = 200;
